export default {
    primary: [
        '#e8f0ff',
        '#e8f0ff',
        '#e8f0ff',
        '#d1dcff',
        '#a2b7fa',
        '#6f8ff5',
        '#3b65ef',
        '#2957ee',
        '#184cee',
        '#073ed4',
    ],
    positive: [
        '#e4fdfa',
        '#d7f4f0',
        '#b3e6df',
        '#8cd7cd',
        '#6ccbbe',
        '#57c3b4',
        '#40b8a8',
        '#37a99a',
        '#289689',
        '#078376'
    ],
    negative: [
        '#ffe8ec',
        '#ffe8ec',
        '#ffe8ec',
        '#ffd1d6',
        '#fba1aa',
        '#f66e7c',
        '#f13b4d',
        '#f0273b',
        '#ef162e',
        '#d50621',
    ],
    observe: [
        '#fff3e0',
        '#ffe6ca',
        '#ffcc99',
        '#ffb063',
        '#ff9f43',
        '#ff8918',
        '#ff8105',
        '#e46e00',
        '#cc6100',
        '#b15200'
    ],
    mystery: [
        '#f7e9ff',
        '#e8cfff',
        '#cd9bff',
        '#b974ff',
        '#9936fe',
        '#8b19fe',
        '#8309ff',
        '#7100e4',
        '#6400cc',
        '#5600b4'
    ],
};
